import flatMap from 'array.prototype.flatmap';
import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';
import VeeValidate from 'vee-validate';
import { initSentry } from '@/lib/sentry';

import setupValidation from '@/utils/setup-validation';

import validationMessagesEn from 'vee-validate/dist/locale/en';
import validationMessagesNl from 'vee-validate/dist/locale/nl';
import validationMessagesPt from 'vee-validate/dist/locale/pt_PT';
import validationMessagesFr from 'vee-validate/dist/locale/fr';
import validationMessagesEs from 'vee-validate/dist/locale/es';
import validationMessagesDe from 'vee-validate/dist/locale/de';

import wysiwyg from 'vue-wysiwyg';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';

import 'vue-wysiwyg/dist/vueWysiwyg.css';
import '@fortawesome/fontawesome-svg-core/styles.css';

import App from '@/App.vue';
import router from '@/router';
import i18n from '@/locales';
import store from '@/store';
import { EventBus } from '@/utils/event-bus';
import syncCookies from '@/utils/sync-cookies';
import ImageLoader from '@/directives/image-loader';
import DateFormatFilter from '@/filters/date-format';
import '@/styles/element.css';
import '@/styles/tailwind.css';
import '@/styles/manifest.css';
import LaunchDarklyPlugin from '@/plugins/launchDarkly';

syncCookies();

flatMap.shim();

/* eslint-disable */
// Google Tag Manager
if (process.env.VUE_APP_GTM_ID !== '') {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', process.env.VUE_APP_GTM_ID);
}
// End Google Tag Manager
/* eslint-enable */

Vue.config.productionTip = false;

/**
 * Explicitly enabling vue devtools when not in production
 * in order to aid inspecting and debugging
 */
if (process.env.VUE_APP_ENV !== 'production') {
    Vue.config.devtools = true;
}

Vue.use(ElementUI, { locale });
Vue.use(Vuex);
Vue.use(VeeValidate, {
  inject: false,
  i18n,
  dictionary: {
    'en-GB': validationMessagesEn,
    nl: validationMessagesNl,
    'pt-PT': validationMessagesPt,
    fr: validationMessagesFr,
    es: validationMessagesEs,
    de: validationMessagesDe,
  },
});
Vue.use(wysiwyg);

Vue.directive('image-loader', ImageLoader);

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    // eslint-disable-next-line no-param-reassign
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Vue.filter('formatDate', DateFormatFilter);

Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return EventBus;
    },
  },
});

Vue.use(LaunchDarklyPlugin, {
  clientId: process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID,
  context: {
    key: 'anonymous-user',
    kind: 'user',
    anonymous: true,
  },
});

initSentry(Vue, router);

const app = new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');

setupValidation();

export default app;
